export const inputCls = "min-h-[46px] rounded-xl border border-sand bg-white px-3.5 text-sm text-navy focus:border-gold focus:ring-2 focus:ring-gold/30 outline-none transition w-full";

export const PANEL = "bg-white rounded-2xl border border-sand p-5";

const PATHWAY_STYLES = {
  legacy: "bg-[#E6F2EC] text-[#0E4B36] border-[#B9DCCB]",
  family: "bg-[#F7E7EC] text-[#4A1024] border-[#E4BFCB]",
  medicare: "bg-[#E6ECF8] text-[#0F2F6B] border-[#BCCBEA]",
  complete: "bg-[#EEE7F6] text-[#2E1650] border-[#D2C3E6]",
};

export function PathwayBadge({ pathway, label }) {
  const cls = PATHWAY_STYLES[pathway] || PATHWAY_STYLES.complete;
  return (
    <span className={`inline-block whitespace-nowrap text-[11px] font-bold rounded-full border px-2.5 py-1 ${cls}`} data-testid="pathway-badge">
      {label || "Legacy Checkup"}
    </span>
  );
}

export function ApptPill({ status }) {
  const active = status && status !== "none";
  return (
    <span className={`text-xs font-bold px-2.5 py-1 rounded-full ${active ? "bg-gold-light text-gold border border-sand" : "bg-cream-dark text-slate-500"}`}>
      {status}
    </span>
  );
}

export function BarList({ title, items, testid }) {
  const max = Math.max(1, ...items.map((i) => i.count));
  return (
    <div className={PANEL} data-testid={testid}>
      <h3 className="font-serif text-xl font-semibold text-navy mb-4">{title}</h3>
      {items.length === 0 && <p className="text-sm text-slate-500">No data yet.</p>}
      <div className="space-y-3">
        {items.map((i) => (
          <div key={i.name}>
            <div className="flex justify-between text-xs font-bold text-navy mb-1">
              <span className="truncate pr-2">{i.name}</span>
              <span className="text-gold shrink-0">{i.count}</span>
            </div>
            <div className="h-2 bg-sand/50 rounded-full overflow-hidden">
              <div className="h-full bg-gold rounded-full" style={{ width: `${(i.count / max) * 100}%` }} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function TableHead({ columns }) {
  return (
    <thead>
      <tr className="text-left text-xs uppercase tracking-wider text-slate-500 border-b border-sand">
        {columns.map((h) => (
          <th key={h} className="py-2.5 pr-4 font-bold">{h}</th>
        ))}
      </tr>
    </thead>
  );
}
